import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const addStakeholder = async (data) => {
  const response = await gatewayInstance.post(
    `${SERVICE_ENDPOINT.TRANSPORT}/stakeholdercreation`,
    data,
  );
  return response.data;
};

export const updateStakeholder = async (data) => {
  return await gatewayInstance.put(
    `${SERVICE_ENDPOINT.TRANSPORT}/stakeholdercreation`,
    data,
  );
};

export const searchStakeholder = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/stakeholder/search`,
      data,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const stakeholderById = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/stakeholdercreation/${id}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const agreementByStkId = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/agreement/by-stakeholder/${id}`,
    );
    return response;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const stakeholderConfigByStakeholderAndConfig = async (
  stkId,
  config,
) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/stakeholderConfig/by-stakeholder-and-config/${stkId}/${config}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const isStakeholderUserEnable = async (ids) => {
  try {
    const response = await gatewayInstance.get(
        `${SERVICE_ENDPOINT.TRANSPORT}/stakeholder/stakeholder-user-enable/${ids}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};
